import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { SharedService } from '../../../../../shared/shared.service';
import { InvoicesHD, InvoicePost } from './invoice';
import { InvoiceService } from '../../invoices.service';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css']
})
export class InvoicesComponent implements OnInit {
  originalDataSource = [];
  dataSource: InvoicesHD[];
  sessionId = sessionStorage.getItem('com-session-id');
  date: Date;

  constructor(
    private httpclient: HttpClient,
    public sharedService: SharedService,
    public invoice: InvoiceService
  ) { }

  ngOnInit() {
    this.sharedService.loadingActive = true;
    // tslint:disable-next-line:max-line-length
    this.httpclient.get<any>(`${this.sharedService.URL}/dbTransactionHD?SessionID=${this.sessionId}&Search=*`).subscribe(Response => {
      console.log(Response);
      this.dataSource = Response.dbTransactionHD_response.view;
      if(this.dataSource !== null){
        this.dataSource.forEach(element => {
          this.date = new Date(element.INVOICEDATE);
          this.date.setDate(this.date.getDate() + 7);
          element.DUEDATE = this.date;
          this.sharedService.loadingActive = false;
        });
        this.originalDataSource = JSON.parse(JSON.stringify(this.dataSource)); // To copy and not reference
        this.dataSource = this.originalDataSource.filter(item => !item['STATUS']);
      } else {
        this.sharedService.loadingActive = false;
      }
    });
  }

  clickEdit(data) {
    this.invoice.setInvoice(0);
    sessionStorage.setItem('invoice-id', data);
  }

  clickNew() {
    this.invoice.setInvoice(1);
  }

  toggleCancelled(pEvent) {
    if (pEvent.value) {
      this.dataSource = this.originalDataSource;
    } else {
      this.dataSource = this.originalDataSource.filter(item => !item['STATUS']);
    }
  }
}
